import { Button, TextProps } from '@bonanza-social/moonlight';
import { memo, useMemo } from 'react';
import { useNavigation } from '@bonanza-social/navigation';
import { StackNavigationProp } from '@react-navigation/stack';
import { useDispatch } from '@bonanza-social/toolkit/state';
import { launchGame } from '@bonanza-social/games';
import { NotificationCTAProps } from '../state';

function NotificationCTA({
  close,
  actionType,
  promotionId,
  gameId,
}: NotificationCTAProps) {
  const dispatch = useDispatch();
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const action = useMemo(() => {
    switch (actionType) {
      case 'Promotions':
        return () =>
          promotionId
            ? navigation.navigate('PromoDetails', {
                id: promotionId,
              })
            : navigation.navigate('Promos');
      case 'Quests':
        return () =>
          promotionId
            ? navigation.navigate('QuestDetails', {
                id: promotionId,
              })
            : navigation.navigate('Quests');
      case 'Shop':
        return () => navigation.navigate('Shop');
      case 'Rewards':
        return () => navigation.navigate('Rewards');
      case 'Lobby':
        return () => navigation.navigate('Home');
      case 'LaunchGame':
        return () => (gameId ? dispatch(launchGame({ id: gameId })) : null);
      default:
        return;
    }
  }, [actionType, promotionId, gameId, dispatch, navigation]);

  const locKey = useMemo(() => {
    const key = (() => {
      switch (actionType) {
        case 'Promotions':
          return `cta_Promotions_${promotionId ? 'single' : 'other'}`;
        case 'Quests':
          return `cta_Quests_${promotionId ? 'single' : 'other'}`;
        case 'Shop':
        case 'Rewards':
        case 'Lobby':
          return `cta_${actionType}`;
        case 'LaunchGame':
          return 'cta_LaunchGame';
        default:
          return null;
      }
    })();

    return key;
  }, [actionType, promotionId]);

  if (!locKey || !action) return null;

  return (
    <Button
      width="100%"
      locNS="notifications"
      locKey={locKey as TextProps['locKey']}
      variant="primary"
      onPress={() => {
        close();
        action();
      }}
    />
  );
}

export default memo(NotificationCTA);
